import React from 'react'
import { log } from '../lib/logger'

// Rede de segurança de render. Não existia nenhuma, e no React um erro lançado durante o
// render desmonta a árvore INTEIRA: uma data malformada vinda de um device apagava o
// painel todo e deixava a tela branca, sem nada que dissesse o que aconteceu. Com esta
// guarda, o erro fica contido, vai ao log com a pilha, e o operador tem um caminho de
// volta em vez de um F5 às cegas.
//
// É rede de segurança, não desculpa: cada erro que cair aqui continua a ser um defeito a
// corrigir na origem, e é por isso que a mensagem mostra o texto do erro em vez de um
// "algo correu mal" que ninguém consegue reportar.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  static getDerivedStateFromError(error) {
    return { error }
  }

  componentDidCatch(error, info) {
    log.error('render falhou', error, info?.componentStack)
  }

  render() {
    if (!this.state.error) return this.props.children

    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950 p-6">
        <div className="max-w-lg w-full bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded-xl p-6">
          <h1 className="text-base font-semibold text-slate-800 dark:text-slate-100">
            A tela não pôde ser desenhada
          </h1>
          <p className="mt-2 text-sm text-slate-500 dark:text-slate-400">
            O resto do sistema continua a funcionar e nenhum dado foi perdido. Recarregue
            para voltar; se repetir, o texto abaixo é o que o suporte precisa.
          </p>
          <pre className="mt-4 text-xs font-mono bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-700 rounded-md p-3 overflow-x-auto text-slate-600 dark:text-slate-300">
            {String(this.state.error?.message || this.state.error)}
          </pre>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 text-sm font-semibold px-3 py-1.5 rounded-md bg-brand text-white hover:bg-brand-700"
          >
            Recarregar
          </button>
        </div>
      </div>
    )
  }
}
